import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import { base64ToStr  } from "../../utils/base64Util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import DatePicker , { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import { faArrowTrendUp, faMagnifyingGlass, faEdit, faTrash, faUsers } from "@fortawesome/free-solid-svg-icons";

import api from "../../services/api";
import { baixarArquivo } from "../../utils/downloadUtil";

import './SolicitacaoComunicacao.css';
import { 	SITUACAO_SOLICITACAO_RASCUNHO, SITUACAO_SOLICITACAO_LIBERADA_PROCESSAMENTO, SITUACAO_SOLICITACAO_EM_PROCESSAMENTO,
			SITUACAO_SOLICITACAO_PROCESSADA, 
 } from "../../providers/constSituacoesSolicitacao";

import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import { RESPONSAVEL_TECNICO, DIRIGENTE_TI } from "../../providers/constAtribuicoesGestor";
import { GESTOR_API, GESTOR_ARQUIVO_GV } from "../../providers/constGestorFornecedor";
import { AUDIENCIA_SOL_COM_CONSUMIDOR_API, AUDIENCIA_SOL_COM_FORNECEDOR_API, AUDIENCIA_SOL_COM_OPERADOR_API, AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV, AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV, AUDIENCIA_SOL_COM_PONTOS_FOCAIS } from "../../providers/constAudienciaSolicitacaoComunicacao";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

const todasSituacoes = [
	SITUACAO_SOLICITACAO_RASCUNHO,
	SITUACAO_SOLICITACAO_LIBERADA_PROCESSAMENTO,
	SITUACAO_SOLICITACAO_EM_PROCESSAMENTO,
	SITUACAO_SOLICITACAO_PROCESSADA
];

registerLocale("pt_br", pt_br);
export const SolicitacaoComunicacaoList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.initialState = {
				criterioPesquisa: {
					numero: '',
					orgao: '',
					audiencia: '',
					situacao: '',
					fornecedoraCedida: '',
					fornecedoraConsumida: '',
					unidadeFederacao: '',
					esferaAdministrativa: '',
					tipoGestor: '',
					dataInicio: '',
					dataFim: '',
				},
				orgaos: [],
				situacoes: [...todasSituacoes],
				fornecedoras: [],
				arquivosGV: [],
				esferasAdministrativas: [ESTADUAL, FEDERAL, MUNICIPAL],
				unidadesFederacao: [],
				tiposGestores: [GESTOR_API, GESTOR_ARQUIVO_GV, DIRIGENTE_TI, RESPONSAVEL_TECNICO],
				audiencias: [AUDIENCIA_SOL_COM_CONSUMIDOR_API, AUDIENCIA_SOL_COM_FORNECEDOR_API, AUDIENCIA_SOL_COM_OPERADOR_API, AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV, AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV, AUDIENCIA_SOL_COM_PONTOS_FOCAIS],
				carregandoOrgaos: false,
				carregandoArquivosGV: false,
				carregandoFornecedoras: false,
				carregandoUnidadesFederacao: false,
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				botoesHabilitados : true,
				exibeModalConfirmacao: false,
				msgModal: '',
				operacao: null,
			};
			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleEsferaAdministrativaChange = this.handleEsferaAdministrativaChange.bind(this);
			this.handleUnidadeFederacaoChange = this.handleUnidadeFederacaoChange.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.carregarFornecedoras = this.carregarFornecedoras.bind(this);
			this.carregarArquivosGV = this.carregarArquivosGV.bind(this);
			this.carregarUnidadesFederacao = this.carregarUnidadesFederacao.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.fechaModal = this.fechaModal.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.excluirSolicitacao = this.excluirSolicitacao.bind(this);
			this.liberarSolicitacaoProcessamento = this.liberarSolicitacaoProcessamento.bind(this);
			this.mostraRelatorioCSV = this.mostraRelatorioCSV.bind(this);
			this.mostraRelatorioPDF = this.mostraRelatorioPDF.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Solicitações de Comunicação</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			
			this.carregarOrgaos();
			this.carregarFornecedoras();
			this.carregarArquivosGV();
			this.carregarUnidadesFederacao();

			if (localStorage.getItem('stateParent') && 
				localStorage.getItem('stateParentUrl') && 
				localStorage.getItem('stateParentUrl') === this.props.location.pathname) {
				const stateParent = JSON.parse(base64ToStr(localStorage.getItem('stateParent')));
				localStorage.removeItem('stateParent');
				localStorage.removeItem('stateParentUrl');
				this.executarPesquisaAnterior(stateParent);
			} else if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { 
				criterioPesquisa, resultadoPesquisa, pesquisaExecutada, orgaos, situacoes, fornecedoras, arquivosGV,
				esferasAdministrativas, unidadesFederacao, tiposGestores, carregandoOrgaos, carregandoArquivosGV,
				carregandoFornecedoras, carregandoUnidadesFederacao,
			} = this.state;
			const { content } = resultadoPesquisa;
			const exibeBotoes = content && content.length > 0;
			const { numero, orgao, audiencia, situacao, fornecedora, arquivoGV, unidadeFederacao, esferaAdministrativa, tipoGestor, dataInicio, dataFim } = criterioPesquisa;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalConfirmacao}
						handleOk={() => this.executaOperacao()}
						handleCancel={() => this.fechaModal()}
						message={this.state.msgModal}/>

					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Número solicitação:</label>
										<input type="text" name="numero" 
											value={numero}  
											onChange={this.handleInputChange} maxLength={11}/>
										
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Audiência:</label>
										<SelectSearch
											id="audiencia"
											name="audiencia"
											options={this.state.audiencias.map(audiencia => ({ value: audiencia.id, label: audiencia.nome }))}
											includeAllOption={true}
											allOptionName="Todas"
											onChange={this.handleInputChange}
											value={audiencia}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Situação:</label>
										<SelectSearch
											id="situacao"
											name="situacao"
											options={situacoes.map(situacao => ({ value: situacao.id, label: situacao.nome }))}
											includeAllOption={true}
											allOptionName="Todas"
											onChange={this.handleInputChange}
											value={situacao}
										/>
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Destinatários:</label>
										<SelectSearch
											id="tipoGestor"
											name="tipoGestor"
											options={tiposGestores.map(tipo => ({ value: tipo.codigo, label: tipo.nome }))}
											includeAllOption={true}
											allOptionName="Todos"
											onChange={this.handleInputChange}
											value={tipoGestor}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sd">
								<div className="field">
									<div className="input">
										<label>Esfera Administrativa:</label>
										<SelectSearch
											id="esferaAdministrativa"
											name="esferaAdministrativa"
											allOptionName="Todas"
											options={esferasAdministrativas.map(esfera => ({ value: esfera.codigo, label: esfera.nome }))}
											includeAllOption={true}
											onChange={this.handleEsferaAdministrativaChange}
											value={esferaAdministrativa}
										/>
									</div>
								</div>
							</div>

							<div className="col-sd">
								<div className="field">
									<div className="input">
										<label>Unidade da Federação:</label>
										{ carregandoUnidadesFederacao === false && unidadesFederacao.length > 0 &&
											<SelectSearch
												id="unidadeFederacao"
												name="unidadeFederacao"
												allOptionName="Todas"
												options={unidadesFederacao.map(unidade => ({ value: unidade.id, label: unidade.nome }))}
												includeAllOption={true}
												onChange={this.handleUnidadeFederacaoChange}
												value={unidadeFederacao}
											/>
										}
										{ carregandoUnidadesFederacao === false && unidadesFederacao.length === 0 &&
											<p>Nenhuma Unidade da Federação encontrada.</p>
										}
										{ carregandoUnidadesFederacao === true  && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Órgão:</label>
										{ carregandoOrgaos === false && orgaos.length > 0 &&
											<SelectSearch
												id="orgao"
												name="orgao"
												options={orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
												includeAllOption={true}
												onChange={this.handleInputChange}
												value={orgao}
											/>
										}
										{ carregandoOrgaos === false && orgaos.length === 0 &&
											<p>Nenhum órgão encontrado.</p>
										}
										{ carregandoOrgaos === true  && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{ carregandoFornecedoras === false  && 
										<SelectSearch
												id="fornecedora"
												name="fornecedora"
												options={fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome }))}
												includeAllOption={true}
												allOptionName="Todas"
												onChange={this.handleInputChange}
												value={fornecedora}
											/>
										}
										{ carregandoFornecedoras === true  && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Arquivo:</label>
										{ carregandoArquivosGV === false  && 
										<SelectSearch
												id="arquivoGV"
												name="arquivoGV"
												options={arquivosGV.map(arquivo => ({ value: arquivo.id, label: arquivo.nome }))}
												includeAllOption={true}
												onChange={this.handleInputChange}
												value={arquivoGV}
											/>
										}
										{ carregandoArquivosGV === true  && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Data Inicial:</label>
										<DatePicker locale="pt_br" dateFormat="dd/MM/yyyy" selected={dataInicio} 
										onChange={data => {
													const criterioPesquisa = this.state.criterioPesquisa;
													criterioPesquisa['dataInicio'] = data;
													this.setState((prevState) => ({ ...prevState, criterioPesquisa}))}}/>
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Data Final:</label>
										<DatePicker locale="pt_br" dateFormat="dd/MM/yyyy" selected={dataFim} onChange={data => {
													const criterioPesquisa = this.state.criterioPesquisa;
													criterioPesquisa['dataFim'] = data;
													this.setState((prevState) => ({ ...prevState, criterioPesquisa}))}} />
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<Link to="/solicitacao-comunicacao/new"> 
									<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Nova</button>
								</Link>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col">Número</th>
												<th scope="col">Situação</th>
												<th scope="col">Audiência</th>
												<th scope="col">UFs</th>
												<th scope="col">Pontos focais <br/>Naturezas</th>
												<th scope="col">Esferas</th>
												<th scope="col">Órgãos</th>
												<th scope="col">APIs</th>
												<th scope="col">Arquivos</th>
												<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((solicitacao, index) =>
													<tr key={index} >
														<td>{solicitacao.numero}</td>
														<td>{solicitacao.nomeSituacao}</td>
														<td>{solicitacao.nomeAudiencia}</td>
														<td>{(solicitacao.ufs && solicitacao.ufs.length > 0) && <>{solicitacao.ufs.map((uf, index) => <>{uf.id} {index < solicitacao.ufs.length - 1 ? <br/> : null}</>)}</>}</td>
														<td>{(solicitacao.naturezasJuridicas && solicitacao.naturezasJuridicas.length > 0) && <>{solicitacao.naturezasJuridicas.map((natureza, index) => <>{natureza.id} {index < solicitacao.naturezasJuridicas.length - 1 ? <br/> : null}</>)}</>}</td>
														<td>{(solicitacao.esferasAdministrativas && solicitacao.esferasAdministrativas.length > 0) && <>{solicitacao.esferasAdministrativas.map((esfera, index) => <>{esfera.nome} {index < solicitacao.esferasAdministrativas.length - 1 ? <br/> : null}</>)}</>}</td>
														<td>{(solicitacao.orgaos && solicitacao.orgaos.length > 0) && <>{solicitacao.orgaos.map((orgao, index) => <>{orgao.nome} {solicitacao.operadoresAPI ? '(O)' : ''} {index < solicitacao.orgaos.length - 1 ? <br/> : null}</>)}</>}</td>
														<td>{(solicitacao.aplicacacoesFornecedoras && solicitacao.aplicacacoesFornecedoras.length > 0) && <>{solicitacao.aplicacacoesFornecedoras.map((fornecedora, index) => <>{fornecedora.nome} {solicitacao.consumidoresAPI ? '(C)' : solicitacao.fornecedoresAPI ? '(F)' : ''} {index < solicitacao.aplicacacoesFornecedoras.length - 1 ? <br/> : null}</>)}</>}</td>
														<td>{(solicitacao.arquivosGV && solicitacao.arquivosGV.length > 0) && <>{solicitacao.arquivosGV.map((arquivo, index) => <>{arquivo.nome} {solicitacao.consumidoresArquivosGV ? '(C)' : solicitacao.fornecedoresArquivosGV ? '(F)' : ''} {index < solicitacao.arquivosGV.length - 1 ? <br/> : null}</>)}</>}</td>

														<td className="text-center">
															<div className="actions">
																{ solicitacao.exclusaoPermitida &&
																	<button type="button" onClick={() => this.confirmaOperacao(solicitacao, this.excluirSolicitacao, "Deseja realmente excluir a solicitação de comunicação?")} 
																			disabled={!this.state.botoesHabilitados}  
																			title="Excluir a solicitação de comunicação">
																		<span className="sr-only">Excluir</span>
																		<FontAwesomeIcon icon={faTrash} id="danger" />
																	</button>
																}

																{ solicitacao.alteracaoPermitida &&
																	<Link to={`/solicitacao-comunicacao/edit/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Editar a solicitação de comunicação">
																			<span className="sr-only">Editar</span>
																			<FontAwesomeIcon icon={faEdit} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ solicitacao.liberacaoProcessamentoPermitida &&
																	<button type="button" onClick={() => this.confirmaOperacao(solicitacao, this.liberarSolicitacaoProcessamento, "Deseja realmente liberar a solicitação de comunicação para processamento?")}  
																			disabled={!this.state.botoesHabilitados}  
																			title="Liberar a solicitação de comunicação para processamento">
																		<span className="sr-only">Liberar para processamento</span>
																		<FontAwesomeIcon icon={faArrowTrendUp} style={{color: "#1351b4"}} />
																	</button>
																}

																{ solicitacao.visualizacaoMensagensPermitida &&
																	<Link to={`/solicitacao-comunicacao/messages/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Visualizar as mensagens enviadas para os gestores">
																			<span className="sr-only">Visualizar mensagens enviadas para os gestores</span>
																			<FontAwesomeIcon icon={faUsers} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ solicitacao.visualizacaoPermitida &&
																	<Link to={`/solicitacao-comunicacao/view/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Visualizar a solicitação de comunicação">
																			<span className="sr-only">Visualizar</span>
																			<FontAwesomeIcon icon={faMagnifyingGlass} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}
															
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma solicitação encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState((prevState) => ({ ...prevState,  criterioPesquisa }));
		}

		handleEsferaAdministrativaChange(evento){
			const esferaAdministrativa =  evento.target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa.esferaAdministrativa = esferaAdministrativa;
			this.setState((prevState) => ({ ...prevState,  criterioPesquisa }));

			this.carregarOrgaos(esferaAdministrativa, criterioPesquisa.unidadeFederacao);
		}

		handleUnidadeFederacaoChange(evento){
			const unidadeFederacao =  evento.target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa.unidadeFederacao = unidadeFederacao;
			this.setState((prevState) => ({ ...prevState,  criterioPesquisa }));

			this.carregarOrgaos(criterioPesquisa.esferaAdministrativa, unidadeFederacao);
		}

		carregarOrgaos(esferaAdministrativa, unidadeFederacao){ 
			this.setState((prevState) => ({ ...prevState, carregandoOrgaos: true}))
			let url = '/api/orgao/clientes?ativos=true';
			
			if (esferaAdministrativa) {
				url += `&esferasAdministrativas=${[esferaAdministrativa]}`;
			}

			if (unidadeFederacao) {
				url += `&unidadesFederacao=${[unidadeFederacao]}`;
			}
			
			api.get(url)
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, orgaos: response.data }));
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os órgãos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoOrgaos: false}));
				});
		}

		carregarFornecedoras(){
			this.setState((prevState) => ({ ...prevState,  carregandoFornecedoras: true }));

			api.get('/api/aplicacao-fornecedora/adesoes-ativas')
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, fornecedoras: response.data})); 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as APIs consumidas." + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				}).finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoFornecedoras: false}));
				});
		}

		carregarArquivosGV(){
			this.setState((prevState) => ({ ...prevState,  carregandoArquivosGV: true }));

			let url = '/api/arquivo-gv';

			api.get(url)
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, arquivosGV: response.data })) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os Arquivos de Grandes Volumes.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoArquivosGV : false}));
				});
		}

		carregarUnidadesFederacao(){
			this.setState((prevState) => ({ ...prevState,  carregandoUnidadesFederacao: true }));

			api.get('/api/unidade-federacao')
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, unidadesFederacao: response.data})); 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as UFs." + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				}).finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoUnidadesFederacao: false}));
				});
		}

		executarPesquisaAnterior(state) {
			const lastState = state ?? this.props.filters[this.props.location.pathname];

			this.setState((prevState) => ({ ...prevState, 
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}), () => {
				if (lastState) {
					const previousPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(previousPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){
			const {criterioPesquisa} = this.state;
			criterioPesquisa['pagina'] = pagina;
			const url = '/api/solicitacao-comunicacao/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState((prevState) => (
					{ ...prevState, 
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}), () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as solicitações de comunicação. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();

			this.setState((prevState) => (
				{ ...prevState, 
					criterioPesquisa: {
						numero: '',
						orgao: '',
						audiencia: '',
						situacao: '',
						esferaAdministrativa: '',
						unidadeFederacao: '',
						fornecedora: '',
						arquivoGV: '',
						tipoGestor: '',
						dataInicio: '',
						dataFim: '',
					},
					resultadoPesquisa: {},
					pesquisaExecutada: false,
					exibeModalConfirmacao: false,
					botoesHabilitados : true,
				}), () => {
					this.props.deleteState(this.state, this.props.location.pathname);
				}
			)
		}

		confirmaOperacao(solicitacao, operacao, msgModal) {
			this.setState((prevState) => (
				{ ...prevState, 
					exibeModalConfirmacao: true,
					solicitacaoAlvo: solicitacao,
					operacao,
					msgModal,
				}
			));
		}

		executaOperacao () {
			this.setState((prevState) => ({ ...prevState, botoesHabilitados:false}));
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			this.state.operacao(this.state.solicitacaoAlvo);
			this.fechaModal();
		}

		excluirSolicitacao (solicitacao){
			api.delete(`/api/solicitacao-comunicacao/${solicitacao.id}`)
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, pesquisaExecutada : true,	})) 
					this.pesquisar();
					this.props.exibeMensagemSucesso("Solicitação de comunicação excluída com sucesso.");
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível excluir a solicitação de comunicação.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState((prevState) => ({ ...prevState, botoesHabilitados:true}));
					this.props.escondeAguardando();
				});
		}

		liberarSolicitacaoProcessamento (solicitacao){
			api.put(`/api/solicitacao-comunicacao/liberar-processamento/${solicitacao.id}`)
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, pesquisaExecutada : true,})) 
					this.pesquisar();
					this.props.exibeMensagemSucesso("Solicitação de comunicação liberada para processamento com sucesso.");
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível liberar a solicitação de comunicação para processamento.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState((prevState) => ({ ...prevState, botoesHabilitados:true}));
					this.props.escondeAguardando();
				});
		}

		fechaModal () {
			this.setState((prevState) => ({ ...prevState, exibeModalConfirmacao: false, }));
		}

		mostraRelatorioCSV(e){
			this.mostraRelatorio(e, 'csv');
		}

		mostraRelatorioPDF(e){
			this.mostraRelatorio(e, 'pdf');
		}

		mostraRelatorio(e, tipo){
			const { criterioPesquisa } = this.state;
			const url = `/api/solicitacao-comunicacao/${tipo}`;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState((prevState) => ({ ...prevState, botoesHabilitados : false}));

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioSolicitacoesComunicacao.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de solicitações de comunicação';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState((prevState) => ({ ...prevState, botoesHabilitados : true}));
				});
		}
		
	}

) // redux
); // router